<template>
	<el-card class="menuBody" style="width: 100%;" shadow="never">
		<left-project-tree @chooseNode="chooseNode" />
		<el-card class="box-card">
			<div class="search-title">
				仪表收费项
			</div>
			<p style="font-weight: bold; color: #EB5409; margin: 10px 0px" v-show="projectId">选中项目【{{ projectName }}】</p>
			<div class="search-button-tools">
				<el-button type="primary" v-Jurisdiction="'hydropower.web.charge.feeitem.add'" :disabled="!projectId" size="small" v-debounce @click="doOpenEdit">添加</el-button>
				<el-button type="primary" v-Jurisdiction="'hydropower.web.charge.feeitem.listPage'" size="small" :loading="tableLoading" @click="doSearch">刷新数据</el-button>
			</div>
			<el-table :data="tableData" row-key="id" border :stripe="true" v-loading="tableLoading" tooltip-effect="light">
				<el-table-column width="200" show-overflow-tooltip prop="projectName" label="项目"></el-table-column>
				<el-table-column width="100" prop="meterType" label="类型"></el-table-column>
				<el-table-column width="140" show-overflow-tooltip prop="category" label="一级分类"></el-table-column>
				<el-table-column width="100" prop="price" label="单价(元)" align="right">
					<template slot-scope="scope"> {{ scope.row.price }}元 </template>
				</el-table-column>
				<el-table-column width="100" prop="scale" label="精确度">
					<template slot-scope="scope">
						{{ convertScale(scope.row.scale) }}
					</template>
				</el-table-column>
				<el-table-column width="160" prop="mergeFlagStr" label="收费入口"></el-table-column>
				<el-table-column width="200" prop="subCount" label="收费项个数"></el-table-column>
				<el-table-column width="200" fixed="right" label="操作">
					<template slot-scope="scope">
						<el-button v-Jurisdiction="'hydropower.web.charge.feeitem.edit'" @click="doOpenEdit(scope.row)" type="text" size="small">修改</el-button>
						<el-button v-Jurisdiction="'hydropower.web.charge.feeitem.saveConfig'" @click="doOpenConfigSub(scope.row)" type="text" size="small">配置收费项</el-button>
					</template>
				</el-table-column>
			</el-table>
			<simple-pagination @search="doSearch" />
		</el-card>

		<el-dialog :title="editDlg.title" width="750px" center :visible.sync="editDlg.visible" v-if="editDlg.visible" :destroy-on-close="true">
			<edit-form :defaultFormData="editDlg.formData" @search="doSearch"></edit-form>
		</el-dialog>

		<el-dialog
			:title="subEditDlg.title"
			width="750px"
			center
			:visible.sync="subEditDlg.visible"
			v-if="subEditDlg.visible"
			:destroy-on-close="true"
		>
			<config-feeitem-form :defaultFormData="subEditDlg.formData" @search="doSearch"></config-feeitem-form>
		</el-dialog>
	</el-card>
</template>
<script>
import projectTree from "@/views/common/projectTree.vue";
import LeftProjectTree from "@/components/LeftProjectTree.vue";
import "@/assets/scss/common.scss";
import { scale } from "@/dict/meterDict";
import mixin from "@/mixin/index";
import EditForm from "./components/EditForm.vue";
import ConfigFeeitemForm from "./components/ConfigFeeitemForm.vue";
import { pick } from "lodash";

export default {
	name: "MeterFeeitemIndex",
	components: { projectTree, LeftProjectTree, EditForm, ConfigFeeitemForm },
	mixins: [mixin],
	data() {
		return {
			scale,
			queryListUrl: "/meter/web/feeitem/listPage",
			projectName: "",
			projectId: "",
			editDlg: {
				title: "",
				visible: false,
				formData: {},
			},
			subEditDlg: {
				title: "",
				visible: false,
				formData: {},
			},
		};
	},
	methods: {
		doSearch() {
			this.getList();
		},
		chooseNode(data) {
			this.projectId = data.projectId;
			this.projectName = data.projectName;
		},
		doOpenConfigSub(row) {
			let formData = pick(row, "id", "projectId", "projectName", "meterType", "price");
			this.subEditDlg = {
				visible: true,
				formData: formData,
			};
		},
		doOpenEdit(row) {
			let formData = {};
			if (row && !row instanceof MouseEvent) {
				formData = pick(row, "id", "category", "meterType", "scale", "projectId", "projectName", "mergeFlag");
			} else {
				if (!this.projectId) {
					this.$message("请先选择所属项目");
					return;
				}
				formData = {
					projectId: this.projectId,
					projectName: this.projectName,
					mergeFlag: 0,
				};
			}
			this.editDlg = {
				visible: true,
				formData: formData,
			};
		},
		convertScale(val) {
			const result = this.scale.find((item) => item.value == val);
			return result ? result.label : "";
		},
	},
	mounted() {
		this.doSearch();
	},
};
</script>